import { render, staticRenderFns } from "./CorePRG.vue?vue&type=template&id=259ac226&"
import script from "./CorePRG.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CorePRG.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('259ac226')) {
      api.createRecord('259ac226', component.options)
    } else {
      api.reload('259ac226', component.options)
    }
    module.hot.accept("./CorePRG.vue?vue&type=template&id=259ac226&", function () {
      api.rerender('259ac226', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/core/CorePRG/CorePRG.vue"
export default component.exports